import React from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CardProps,
    Divider,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useLead from 'src/hooks/useLead';
import { Award } from 'react-feather';
import { IPresentationCard } from './types';
import { CapitalizeNames } from 'src/utils/capitalize';

/**
 * Represent the component to send a presentation card to a lead by email
 *
 * @param {*} { ...props }
 * @return {*}
 */
export const PresentationCard = ({
    presentationCard,
    ...props
}: IPresentationCard) => {
    const { t } = useTranslation();
    const { lead, sendPresentationCard } = useLead();

    const title: string = t('PresentationCard.PresentationCard');
    const buttonText: string = t('PresentationCard.SendPresentationCard');

    const handleSendPresentationCard = async () =>
        sendPresentationCard({
            leadId: lead._id,
            presentationCard,
            email: lead.email,
            client: CapitalizeNames(lead.name),
        });

    return (
        <Card {...props} data-testid="presentation-card-component">
            <CardHeader data-testid="presentation-card-header" title={title} />
            <Divider />
            <CardContent>
                <Button
                    data-testid="presentation-card-button"
                    variant="contained"
                    type="submit"
                    size="large"
                    fullWidth
                    color="primary"
                    startIcon={<Award />}
                    onClick={handleSendPresentationCard}
                    style={{
                        height: 60,
                    }}
                >
                    {buttonText}
                </Button>
            </CardContent>
        </Card>
    );
};
